var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.249,
    height: 22.249,
    viewBox: "0 0 22.249 22.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M0-47.5H22.249v22.249H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(0 47.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4380",
    "data-name": "Path 4380",
    d: "M-3.4-1.993H.109c.646,0,1.171-.061,1.171.586V-2.579A1.171,1.171,0,0,0,.109-3.75H-4.575c-1.171,0-2.1,1.244-1.757,2.928,0,0,1.049,5.489,1.122,5.831A2.521,2.521,0,0,0-2.843,6.789H1.232c.646,0,.049-1.11.049-1.757V3.862A1.171,1.171,0,0,1,.109,5.033H-2.233A1.312,1.312,0,0,1-3.4,3.862C-3.5,3.3-4.331-.432-4.331-.432c-.2-1.122.28-1.562.927-1.562",
    transform: "translate(6.917 -41.993)",
    fill: "#ffac33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4381",
    "data-name": "Path 4381",
    d: "M-5.866-1.993H-9.38c-.646,0-1.647-.061-1.647.586V-2.579c0-.646,1-1.171,1.647-1.171H-4.7c1.171,0,2.1,1.244,1.757,2.928,0,0-.956,5.515-1.037,5.855A2.488,2.488,0,0,1-6.318,6.789H-10.5c-.647,0-.525-1.11-.525-1.757V3.862c0,.646,1,1.171,1.647,1.171h2.342A1.312,1.312,0,0,0-5.866,3.862c.1-.561.927-4.294.927-4.294.194-1.122-.281-1.562-.927-1.562",
    transform: "translate(24.493 -41.993)",
    fill: "#ffac33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4382",
    "data-name": "Path 4382",
    d: "M-5.98-2.055c0-4.074-1.586,0-1.586,0s-1.757-4.074-1.757,0S-11.25,3.8-11.25,3.8h7.2S-5.98,2.019-5.98-2.055",
    transform: "translate(18.691 -31.978)",
    fill: "#ffac33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M-14.619-4.218c0,3.967-3.964,10.652-6.441,10.652S-27.5-.251-27.5-4.218c0-3.042.586-3.7,1.757-3.7.8,0,3.528-.016,4.684-.016h4.1c1.708,0,2.342.4,2.342,3.717",
    transform: "translate(32.184 -38.845)",
    fill: "#ffcc4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M-11.963-1.993c0,.646.061,1.171-.586,1.171h-9.368c-.646,0-.586-.525-.586-1.171v-.586a1.239,1.239,0,0,1,1.22-1.171h8.149a1.2,1.2,0,0,1,1.171,1.171Z",
    transform: "translate(28.357 -25.599)",
    fill: "#c1694f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M-14.619-1.08c0,.445.025.805-.805.805H-26.695c-.756,0-.805-.36-.805-.805v-.146a.8.8,0,0,1,.805-.805h11.271a.8.8,0,0,1,.805.805Z",
    transform: "translate(32.184 -25.561)",
    fill: "#c1694f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.f784b0f9d613bbe9c115da59688729af.svg";
export { ForwardRef as ReactComponent };